module.exports = __webpack_public_path__ + "img/dianchi.a9d233c4.png";